import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateTenantCommand } from "Infrastructure/Api/Api";
import { postTenants } from "Infrastructure/Api/Api";
import { getTenantsQueryKey } from "Tenants/Api/Queries/useTenantsQuery";

export function useCreateTenantMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (command: CreateTenantCommand) => postTenants(command),
		onSuccess: () => {
			// Invalidate tenants query to refetch the list
			queryClient.invalidateQueries({
				queryKey: [getTenantsQueryKey(0, 100)],
			});
		},
	});
}
